import {ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, QueryList, ViewChildren} from '@angular/core';
import {OffsetModifier} from '@popperjs/core/lib/modifiers/offset';
import * as _ from 'lodash-es';
import {WidgetLinkingGroupId} from '../../../../enums/widget-linking-group';
import {
    DisplayWidgetLinkingGroup,
    DisplayWidgetLinkingGroupFactory
} from '../../../../factories/display-widget-linking-group.factory';
import {DropdownMenuComponent} from '../../../dropdown-menu';
import {DropdownMenuItem} from '../../../dropdown-menu/dropdown-menu-item';
import {PopperOptions} from '../../../popper-utils/popper-options';

@Component({
    selector: 'ul[widget-linking-group-dropdown]',
    templateUrl: './widget-linking-group-dropdown.component.html',
    styleUrls: [
        '../../../dropdown-menu/dropdown-menu.component.scss',
        './widget-linking-group-dropdown.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WidgetLinkingGroupDropdownComponent extends DropdownMenuComponent implements OnInit {

    public WidgetLinkingGroupId = WidgetLinkingGroupId;

    public override menuItems: Array<DropdownMenuItem<DisplayWidgetLinkingGroup>>;

    public selectedMenuItem: DropdownMenuItem<DisplayWidgetLinkingGroup>;

    @Input()
    public override targetElement: ElementRef;

    @Input()
    public widgetLinkingGroupId: WidgetLinkingGroupId;

    @ViewChildren('item', {read: ElementRef})
    public override itemQueryList: QueryList<ElementRef>;

    public override ngOnInit(): void {
        this.menuItems = DisplayWidgetLinkingGroupFactory
            .getDisplayWidgetLinkingGroups()
            .map<DropdownMenuItem<DisplayWidgetLinkingGroup>>(linkingGroup => ({
                label:    linkingGroup.label,
                value:    linkingGroup,
                callback: this.onCloseCallback.bind(this)
            }));

        this.selectedMenuItem = _.find(
            this.menuItems,
            menuItem => menuItem.value.id === this.widgetLinkingGroupId
        );

        super.ngOnInit();
    }

    protected override initPopper(popperOptions: PopperOptions = {}): void {
        super.initPopper({
            placement: 'bottom-start',
            ...popperOptions
        });
    }

    protected override getPopperOffsetModifier(): OffsetModifier {
        return {
            ...super.getPopperOffsetModifier(),
            options: {
                offset: ({reference}) => [0, -(reference.height + 1)]
            }
        };
    }
}
